module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABRklEQVQ4T62UzSuEURTGfw9CFvIRZSNJFBtRssJWVjbYKEt/kr0NKyvZsFAWko9SFrPRpNmYha8olB6d6R1Nb2Ommd6zfO45v+4557lXVAnbC8CjpFzlse1xYEjSabpMIdgeBCaA1iRhGngD7lMFI0AfcJ3oP0BOUlG243ATeAK+koQB4Bt4TYG6gU6gmOgdCXg3QBtxKUn75SLba8CDpPNUa3PAqKS9itx1QAHaAgqSjqvNq55mewkYK4N6ged6Rf+c9wDvZVAbkG8SNAy0ZN5aZjMqALfAdtLeTngj8VdNDZisHHaAToDwVERepYU6DFtTAxbToDMgfBJxIenTdpivpgbMp0GXwGoCOpD0YjtWW1MD4jn9+Si7YWfh7NKDlXTYjCFtrwD9sZpZYBm4AT4ahHUBM8BR+T8K2BTQ3iAovpo7SVe/2Cm2O2ijGJYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin/calendar.png
// module id = wruk
// module chunks = 2